import React from 'react';

const EnumFormatter = (props) => {
  const { dependentValues } = props;
  if (!dependentValues || !dependentValues.options) return <div />;

  const findEnum = (record) => {
    return record.value === props.value;
  };

  const { options } = dependentValues;
  let value;
  if (options.enumValues) {
    value = options.enumValues.find(findEnum);
  } else if (options.find) {
    value = options.find(findEnum);
  } else {
    console.warn('Options not configured for enum field.', dependentValues);
  }
  return <div title={value ? value.label : null}>{value ? value.label : null}</div>;
};

export default EnumFormatter;
